import { Box, Button, Grid, styled, Typography } from '@mui/material'
import React from 'react'
import { useCommonStyles } from '../../utils';
import IconBackground from '../Common/IconBackground';
import { BUCKET_URL } from '../../ApiSetUp/AuthApi';

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
}));

const Title = styled(Typography)(({ theme }) => ({
    fontSize: "20px",
    fontFamily: "Satoshi-Bold",
}));

const ViewCustomer = ({ setIsOpenViewCustomer, selectedCustomerData }) => {
    // =============== Hooks ===============
    const { classes } = useCommonStyles();

    return (
        <>
            <Grid container padding={"30px"} spacing={3}>
                <Grid item xs={12}>
                    <Title>Basic Detail</Title>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Company Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.companyName || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Display Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.displayName || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Phone No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.phone || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Email</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.email || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Location</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.location || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Privacy Contact</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.privacyContact || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Status</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.status || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Communication Chennels</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.basicDetails?.communicationChannel || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Title>Other Detail</Title>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>GST Treatment</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.GSTTreatment || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Place Of supply</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.placeOfSupply || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>PAN No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.panNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Opening Balance</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.openingBalance || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Currency</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.currency || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Tax Preference</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.taxPreference || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Payment terms</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.paymentTearms || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedCustomerData?.otherDetails?.document &&
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedCustomerData?.otherDetails?.document?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedCustomerData?.otherDetails?.document}`)} />
                            </Box>
                        }
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Website URL</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.websiteUrl || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Twitter</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.twitter || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Skype Name / No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.skypeNameNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Facebook</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.facebook || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Department</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.department || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Designation</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.otherDetails?.designation || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Title>Billing Address</Title>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Attention</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.attention || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Country </KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.country || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Phone no.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.phone || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Address</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.address || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>State</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.state || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>City</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.city || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Pin code</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.zipCode || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Fax No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.billingAddress?.faxNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Title>Shipping Address</Title>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Attention</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.attention : selectedCustomerData?.addressDetail?.shippingAddress?.attention || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Country </KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.country : selectedCustomerData?.addressDetail?.shippingAddress?.country || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Phone no.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.phone : selectedCustomerData?.addressDetail?.shippingAddress?.phone || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Address</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.address : selectedCustomerData?.addressDetail?.shippingAddress?.address || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>State</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.state : selectedCustomerData?.addressDetail?.shippingAddress?.state || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>City</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.city : selectedCustomerData?.addressDetail?.shippingAddress?.city || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Pin code</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.zipCode : selectedCustomerData?.addressDetail?.shippingAddress?.zipCode || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Fax No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.addressDetail?.sameAsBillingAddress ? selectedCustomerData?.addressDetail?.billingAddress?.faxNumber : selectedCustomerData?.addressDetail?.shippingAddress?.faxNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Title>Contact Person</Title>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Salutation</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.contactPersonDetail?.salutation || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>First Name </KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.contactPersonDetail?.firstName || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Last Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.contactPersonDetail?.lastName || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Email Address</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.contactPersonDetail?.email || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Phone No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.contactPersonDetail?.phoneNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Mobile No.</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.contactPersonDetail?.mobileNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Title>Remark</Title>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>{"Remarks (For Internal Use)"}</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedCustomerData?.remark || "NA"}</Answer>
                    </Grid>
                </Grid>
            </Grid>
            <Box display={"flex"} gap={2} padding={"30px"} pt={0}>
                <Button className={classes?.cancelButton} onClick={() => setIsOpenViewCustomer(false)}>Cancel</Button>
            </Box>
        </>
    )
}

export default ViewCustomer